module.exports = "<ea-card-page></ea-card-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaCard/eaCardPage/eaCardPageModule.html
// module id = 962
// module chunks = 12